// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-stack {
  display: grid;
  gap: 100px;
  margin-top: 34px;
}

.employee-not-present-checkbox {
    margin-top: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    color: #333;
}

.employee-not-present-checkbox input {
    width: 16px;
    height: 16px;
    cursor: pointer;
    margin-right: 5px;
}

.employee-not-present-checkbox label {
    cursor: pointer;
    user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/web/component/NotReturnedCard/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".item-list-stack {\r\n  display: grid;\r\n  gap: 100px;\r\n  margin-top: 34px;\r\n}\r\n\r\n.employee-not-present-checkbox {\r\n    margin-top: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 15px;\r\n    color: #333;\r\n}\r\n\r\n.employee-not-present-checkbox input {\r\n    width: 16px;\r\n    height: 16px;\r\n    cursor: pointer;\r\n    margin-right: 5px;\r\n}\r\n\r\n.employee-not-present-checkbox label {\r\n    cursor: pointer;\r\n    user-select: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
